import base from "@/store/utils/api-route/base";

const api = {
    listKomplain: `${base.masterData}qris_ticketing/list_qris_complain`,
    detail: `${base.masterData}qris_ticketing/get_detail_qris_complain?id=`,
    listAkunRefund: `${base.masterData}qris_ticketing/list_account_refund?idoutlet=`,
    refundQris: `${base.masterData}qris_ticketing/refund_qris_complain`,
    listRecomendation: `${base.masterData}qris_ticketing/list_recomendation_snap_transaction_machine?id=`,
    listSnapTransaction: `${base.masterData}qris_ticketing/list_snap_transaction_machine`,
};

export default api;